export default "__VITE_ASSET__fd1000d7__"